import * as React from 'react';

export default class TabList extends React.Component<{}, {}> {
  public render() {
    return <div role="tablist" {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Tabs/TabList.tsx